import React from 'react'
import { Outlet, Navigate } from "react-router-dom"
import { useSelector } from "react-redux"

const FormateurRoute = () => {
  const { userInfo } = useSelector(state => state.auth)

  return userInfo && userInfo.isFormateur ? (
  <Outlet /> 
  ) : ( <Navigate to="/login" replace />
  );
}

export default FormateurRoute